import { render, staticRenderFns } from "./ButtonCollapse.vue?vue&type=template&id=80155c52&"
import script from "./ButtonCollapse.vue?vue&type=script&lang=js&"
export * from "./ButtonCollapse.vue?vue&type=script&lang=js&"
import style0 from "./ButtonCollapse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports